import { IconName } from '@lib/components/Icon'

export const SEARCH_PLACEHOLDER_KEY = 'Chat.Search.Placeholder'
export const SEARCH_CLEAR_KEY = 'Chat.Search.Clear'
export const SEARCH_DEFAULT_DEBOUNCE = 1000
export const SEARCH_ICON_PATH: IconName = 'icons/icon-search'
export const SEARCH_CLEAR_ICON_PATH: IconName = 'icons/icon-close'
